export default "assets/images/logo-f114f7d4.png";